import { useSyncExternalStore } from 'react';

/**
 * The current page's language alternates, for the header's language switcher.
 *
 * Most pages exist at the same path in every language, so the switcher can
 * just swap the prefix. A blog post cannot: the Arabic and English versions
 * of a guide have different slugs. The page's SEO component publishes its
 * real alternates here ({ lang: path }) and the switcher reads them.
 */
let current = null;
const listeners = new Set();

export function publishAlternates(next) {
    current = next;
    listeners.forEach((fn) => fn());
}

export function usePageAlternates() {
    return useSyncExternalStore(
        (fn) => { listeners.add(fn); return () => listeners.delete(fn); },
        () => current
    );
}
